import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import '../Style/NotFound.css';

function NotFound() {
  return (
    <>
      <Header eyebrow="404" title="Page Not Found" />
      <main className="not-found-page">
        <section className="not-found-card">
          <p className="not-found-code">404</p>
          <h1>ページが見つかりません</h1>
          <p className="not-found-copy">
            URL が変わったか、存在しないページにアクセスしています。
            ホームかブログ一覧から戻ってください。
          </p>
          <div className="not-found-actions">
            <Link to="/" className="not-found-link primary">
              Home
            </Link>
            <Link to="/blog" className="not-found-link">
              Blog
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default NotFound;
